import { Injectable } from '@angular/core'
import { NotificationService } from './notification.service'
import { Region } from '../models/Region'

@Injectable()
export class ImportKmlService {

		public companyId: string = localStorage.getItem('companyId')

	constructor(
		public notificationService: NotificationService
		) { }

		public createRegionsFromKMLFile(file: File): Promise<Array<Region>> {
				return new Promise((resolve, reject) => {
						const reader = new FileReader()

						reader.readAsDataURL(file)

						reader.onload = () => {
								const kmlContentDataURL = reader.result.toString()
								const kmlContentBase64 = kmlContentDataURL.split(',')[1]

								const kmlContent = atob(kmlContentBase64)

								const kmlDocument: Document = this.processKML(kmlContent)

								const placemarks: NodeListOf<Element> =
										this.findPlacemarks(kmlDocument)

								if (placemarks.length === 0) {
										this.notificationService.notify('Nenhuma região encontrada no arquivo selecionado' , 400)

										return
								}

								const newRegions: Array<Region> =
										this.createRegiosObjectsFromPlacemarks(placemarks)

								resolve(newRegions)
						}

						reader.onerror = error => {
								reject(error)
						}
				})
		}

		public processKML(kmlContent: string): Document {
		const parser = new DOMParser()

		return parser.parseFromString(kmlContent, 'text/xml')
	}

		public findPlacemarks(kmlDocument: Document): NodeListOf<Element> {
				return kmlDocument.querySelectorAll('Placemark')
		}

		public createRegiosObjectsFromPlacemarks(placemarks: NodeListOf<Element>): Array<Region> {
				const placemarksArray = Array.from(placemarks)

				const makingRegions: Array<Region> = []

				placemarksArray.forEach(placemark => {
						const nameRegion: string = placemark.querySelector('name').textContent
						const colorRegion: string = this.convertStringColorFromStyleUrl(
								placemark.querySelector('styleUrl').textContent
						)

						const hasMultiGeometry: boolean = Boolean(
								placemark.querySelector('MultiGeometry')
						)

						const coordinates = hasMultiGeometry ?
								this.convertMultiGeometryInGoogleLatLngObject(
										placemark.querySelector('MultiGeometry')
								) :
								this.convertCoordinatesInGoogleLatLngObject(
								placemark.querySelector('coordinates').textContent
						)

						makingRegions.push({
								name: this.decodingUTF8(nameRegion),
								color: colorRegion,
								coordinates,
								companyId: this.companyId
						})
				})

				return makingRegions
		}

		public convertStringColorFromStyleUrl(styleUrl: string): string {
				if (!styleUrl) {
						return ''
				}

				const prefixIndex = styleUrl.indexOf('#poly-')

				if (prefixIndex == -1) {
						return ''
				}

				const extractedPart =
						styleUrl.substring(prefixIndex + 6, prefixIndex + 6 + 6)

				return `#${extractedPart}`
		}

		public convertMultiGeometryInGoogleLatLngObject(multiGeometry: Element): Array<google.maps.LatLng> {
				const coordinates: NodeListOf<Element> =
						multiGeometry.querySelectorAll('coordinates') as NodeListOf<Element>

				const coordinatesArray = Array.from(coordinates)

				const googleCoordinates: Array<google.maps.LatLng> = []

				coordinatesArray.forEach(coordinate => {
						const coordinatesConverted: Array<google.maps.LatLng> =
								this.convertCoordinatesInGoogleLatLngObject(coordinate.textContent)

						googleCoordinates.push(...coordinatesConverted)
				})

				return googleCoordinates
		}

		public convertCoordinatesInGoogleLatLngObject(coordinatesString: string): Array<google.maps.LatLng> {
				const lines = coordinatesString.trim().split('\n')

				const coordinatesArray = lines.map(line => {
						const [lng, lat] = line.trim().split(',').map(parseFloat)
						return new google.maps.LatLng(
								lat,
								lng
						)
				})

				return coordinatesArray
		}

		public decodingUTF8(text: string) {
				try {
						return decodeURIComponent(escape(text))
				} catch (error) {
						console.error('Erro ao decodificar a string:', error)
						return text
				}
		}

}
